import LocationAPI from '@/apis/business/account/location-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,

  state: {
    locations: []
  },

  getters: {
    /**
     * @author PVThang
     * @param {*} state
     * @returns lấy danh sách location từ state
     */
    getLocations (state) {
      return state.location
    }
  },

  mutations: {
    /**
     * @author PVThang
     * @param {*} state
     * @param {*} locations
     * @description set locations trong state
     */
    setLocations (state, locations) {
      state.locations = locations
    }
  },

  actions: {
    /**
     * @description Gọi API lấy full location
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getLocations (context) {
      const res = await LocationAPI.getAsync('district-province')

      if (res?.Code === HttpStatusCode.OK) {
        context.commit('setLocations', res.Data?.PageData)
        return true
      } else {
        return res
      }
    }
  }
}
